import React from "react";
import "./Story.css";

function Story() {
  return (
    <div className="story" id="Story" style={{ height: "fit-content" }}>
      {/* If you prefer inline sizing instead of CSS, uncomment the style below and remove className */}
      {/* <h1 style={{ fontFamily: "var(--font-heading)", fontWeight: 800, fontSize: "clamp(1.25rem, 3vw, 2.1rem)", margin: "0 0 18px 0", color: "#111" }}>OUR STORY</h1> */}
      <h1 className="story_title">OUR STORY</h1>

      <p className="story_content">
        My name is Runbier Sabhlok, and Being Human Matters was born in 2022
        out of my lived experience. When my mom was diagnosed with Stage IV
        lung and brain...cancer, I saw up close the hidden struggles patients
        face beyond the disease itself including repeated insurance rejections, mounting
        medical bills, and especially the lack of support for radiation
        expenses. These weren’t medical barriers, but they determine survival
        just as much as the cancer did.
        <br />
        <br />
        At the same time, during my volunteer work at the Princeton Medical
        Center, I saw families whose access to care was decided not by
        treatment options, but by whether they could afford access.
        <br />
        Being Human Matters was created to step into those gaps, helping to bridge the
        care insurance leaves behind so that patients can focus on treatment and
        survival. We’re building this work through corporate and community
        funding and the dedication of 15+ volunteers.
      </p>
    </div>
  );
}

export default Story;
